module.exports = __webpack_public_path__ + "img/319468561816672_image.jpg";